import resolveFeatureFlag from './resolveFeatureFlag';

import type { Flags } from 'models/Global.interface';

/** LaunchDarkly `Flags` or a loose flag bag from HOCs/tests. */
export type UiRevampFlagSource = Flags | Record<string, boolean | undefined>;

/**
 * LaunchDarkly flag key in the LD console is `UI_Revamp` (test/prod on).
 * The React SDK may expose it under several casings; the codebase historically
 * read `uiRevamp`, which is a different string and is often absent in LD.
 */
export const readUiRevampFromFlags = (flags?: UiRevampFlagSource): boolean | undefined => {
  if (!flags) return undefined;
  const byKey = flags as Record<string, boolean | undefined>;
  return byKey.uiRevamp ?? byKey.UI_Revamp ?? byKey.uIRevamp ?? byKey.UIRevamp ?? undefined;
};

/**
 * Whether to render the V2 app shell — the switch in `navigation/index.tsx`
 * that picks the revamped header + body over the original ModelOverviewPage.
 *
 *   localStorage.setItem('uiRevamp', 'false')  // original ModelOverviewPage
 *   localStorage.removeItem('uiRevamp')        // back to default (V2)
 */
export const isUiRevampEnabled = (flags?: UiRevampFlagSource): boolean =>
  resolveFeatureFlag('uiRevamp', readUiRevampFromFlags(flags));

export default isUiRevampEnabled;
